/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Line_Spacing_LabelInputs */



/**
* | output |
* | --- |
* | "Line Spacing (%)" |
*
* @param {Options_Display_Line_Spacing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_line_spacing_label = /** @type {((inputs?: Options_Display_Line_Spacing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Line_Spacing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Interligne (%)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeilenabstand (%)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Interlinea (%)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Межстрочный интервал (%)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Interlineado (%)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("行间距 (%)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("行間隔（％）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पंक्ति रिक्ति (%)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Espaçamento entre linhas (%)")
	return /** @type {LocalizedString} */ ("Line Spacing (%)")
});